import React from "react";
import { Col, Row, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StoreSection } from "../../../../redux/services/store/storePagesApi";
import { CommonTitle } from "Components/Homepage";

type SectionItem = {
  id: number | string;
  slot?: string | null;
  sort_order?: number;
  is_active?: boolean;
  content_json?: any;
};

type SectionWithItems = StoreSection & {
  settings_json?: any;
  items?: SectionItem[];
};

type Props = {
  section?: SectionWithItems;
};

type InstaItem = {
  id: number | string;
  img: string;
  postUrl: string;
  isVideo?: boolean;
};

const fallbackItems: InstaItem[] = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: false,
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: false,
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: true,
  },
  {
    id: 4,
    img: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: false,
  },
  {
    id: 5,
    img: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: false,
  },
  {
    id: 6,
    img: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=900&q=80",
    postUrl: "#",
    isVideo: true,
  },
];

const getItems = (section?: SectionWithItems): InstaItem[] => {
  const items = [...(section?.items || [])]
    .filter((item) => item && item.content_json && item.is_active !== false)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));

  if (!items.length) return fallbackItems;

  return items.map((item, index) => {
    const fb = fallbackItems[index % fallbackItems.length];
    return {
      id: item.id,
      img: item.content_json?.image_url || item.content_json?.image || fb.img,
      postUrl: item.content_json?.post_url || "#",
      isVideo: Boolean(item.content_json?.is_video),
    };
  });
};

const InstagramGallerySection: React.FC<Props> = ({ section }) => {
  const settings = section?.settings_json || {};
  const folloImg = getItems(section);

  const title = settings?.section_title || "Follow Us In Instagram";
  const description =
    settings?.section_subtitle ||
    "Fresh fashion moments, reels, and daily style inspiration.";
  const buttonText = settings?.button_text || "Follow In Instagram";
  const buttonLink = settings?.button_link || "#";

  return (
    <React.Fragment>
      <section className="section pb-0">
        <Container>
          <CommonTitle title={title} dicription={description} />
        </Container>

        <div className="position-relative">
          <Row className="g-0 mt-5">
            {(folloImg || []).map((item, ind) => {
              return (
                <Col key={ind}>
                  <div className="insta-img position-relative overflow-hidden">
                    <Link
                      to={item.postUrl || "#"}
                      className="stretched-link d-block position-relative"
                    >
                      <Image src={item.img} alt="" fluid />
                      <i className="ri-instagram-line insta-icon"></i>
                      {item.isVideo ? (
                        <span className="insta-video-icon">
                          <i className="ri-play-fill"></i>
                        </span>
                      ) : null}
                    </Link>
                  </div>
                </Col>
              );
            })}

            <div className="insta-lable text-center">
              <Link to={buttonLink} className="btn btn-primary btn-hover">
                <i className="ph-instagram-logo align-middle me-1"></i> {buttonText}
              </Link>
            </div>
          </Row>
        </div>
      </section>

      <style>
        {`
          .insta-img {
            min-height: 260px;
          }

          .insta-img img {
            width: 100%;
            height: 100%;
            min-height: 260px;
            object-fit: cover;
            display: block;
          }

          .insta-icon {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 28px;
            color: #fff;
            opacity: 0;
            transition: all 0.3s ease;
            z-index: 2;
          }

          .insta-video-icon {
            position: absolute;
            right: 14px;
            top: 14px;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,0.45);
            color: #fff;
            z-index: 2;
            font-size: 16px;
          }

          .insta-img::after {
            content: "";
            position: absolute;
            inset: 0;
            background: rgba(0,0,0,0.22);
            opacity: 0;
            transition: all 0.3s ease;
            z-index: 1;
          }

          .insta-img:hover::after {
            opacity: 1;
          }

          .insta-img:hover .insta-icon {
            opacity: 1;
          }

          @media (max-width: 991.98px) {
            .insta-img,
            .insta-img img {
              min-height: 220px;
            }
          }

          @media (max-width: 575.98px) {
            .insta-img,
            .insta-img img {
              min-height: 180px;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default InstagramGallerySection;